import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import DualPhotoBackScreen from './DualPhotoBackScreen';
import DualPhotoFrontScreen from './DualPhotoFrontScreen';
import type { DualPhotoCaptureStackParamList } from './dualPhotoCaptureNavigation.types';

export type { DualPhotoCaptureStackParamList } from './dualPhotoCaptureNavigation.types';

const Stack = createNativeStackNavigator<DualPhotoCaptureStackParamList>();

/**
 * Nested stack: back camera → front camera. Used inside DualPhotoCaptureFlow after permission is granted.
 */
export default function DualPhotoCaptureStack() {
  return (
    <Stack.Navigator
      initialRouteName="DualPhotoBack"
      screenOptions={{
        headerShown: false,
        animation: 'slide_from_right',
        contentStyle: { backgroundColor: '#000' },
      }}
    >
      <Stack.Screen
        name="DualPhotoBack"
        component={DualPhotoBackScreen}
        options={{
          // Let the parent (Be Real modal → map) handle the interactive pop; otherwise the nested
          // stack consumes the edge swipe on step 1 with nowhere to pop.
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name="DualPhotoFront"
        component={DualPhotoFrontScreen}
        options={{
          gestureEnabled: false,
        }}
      />
    </Stack.Navigator>
  );
}
